// src/components/feeds/FeedTabs.js
import React from 'react';
import '../../styles/feed-tabs.css';

const FeedTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="feed-tabs">
      <button
        className={`tab-button ${activeTab === 'home' ? 'active' : ''}`}
        onClick={() => onTabChange('home')}
      >
        For You
      </button>
      
      <button
        className={`tab-button ${activeTab === 'global' ? 'active' : ''}`}
        onClick={() => onTabChange('global')}
      >
        Global
      </button>
      
      <button
        className={`tab-button ${activeTab === 'trending-reels' ? 'active' : ''}`}
        onClick={() => onTabChange('trending-reels')}
      >
        🎬 Trending Reels
      </button>
    </div>
  );
};

export default FeedTabs;